function stripTrailingSlash(url) {
  return String(url || "").replace(/\/$/, "");
}

function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

export const IS_DEV_SERVER = process.env.NODE_ENV === "development";
export const DEPLOY_TARGET =
  process.env.VUE_APP_DEPLOY_TARGET || (IS_DEV_SERVER ? "development" : "production");

/**
 * URL defaults by deploy target.
 * - development: vue-cli proxy paths (see vue.config.js)
 * - singlevm: same-origin nginx prefixes on Helen Azure single-VM (HTTP)
 * - security: HTTPS sidecars Auth :8444 / LS :8446 / HSM :8448
 * - production: absolute SE hosts
 */
const URL_DEFAULTS = {
  development: {
    hsmApiBase: "/api/hsm",
    localServerApiBase: "/api",
    localServerHostBase: "",
    authApiBase: "/api/auth",
  },
  security: {
    hsmApiBase: "https://hsm-staging.se-local-server-helen.com:8448/api/hsm",
    localServerApiBase:
      "https://helen-auth-test.swedencentral.cloudapp.azure.com:8446/api",
    localServerHostBase:
      "https://helen-auth-test.swedencentral.cloudapp.azure.com:8446",
    authApiBase:
      "https://helen-auth-test.swedencentral.cloudapp.azure.com:8444/api/auth",
  },
  singlevm: {
    hsmApiBase: "/hsm/api/hsm",
    localServerApiBase: "/localserver/api",
    localServerHostBase: "/localserver",
    authApiBase: "/auth/api/auth",
  },
  production: {
    hsmApiBase: "https://hsm-p.se-local-server-helen.com/api/hsm",
    localServerApiBase: "https://helen-local-test.se-local-server-helen.com/api",
    localServerHostBase: "https://helen-local-test.se-local-server-helen.com",
    authApiBase: "https://auth.se-local-server-helen.com/api/auth",
  },
};

function getTargetDefaults() {
  if (IS_DEV_SERVER && DEPLOY_TARGET === "development") {
    return URL_DEFAULTS.development;
  }
  return URL_DEFAULTS[DEPLOY_TARGET] || URL_DEFAULTS.production;
}

function resolveUrl(envKey, storageKey, defaultsKey) {
  const fromEnv = process.env[envKey];
  if (fromEnv) return stripTrailingSlash(fromEnv);

  if (IS_DEV_SERVER && DEPLOY_TARGET === "development") {
    return getTargetDefaults()[defaultsKey];
  }

  const fromStorage = readStorage(storageKey);
  if (fromStorage) return stripTrailingSlash(fromStorage);

  return getTargetDefaults()[defaultsKey];
}

export function resolveHsmApiBase() {
  return resolveUrl("VUE_APP_HSM_API_BASE", "hsmApiBase", "hsmApiBase");
}

export function resolveLocalServerApiBase() {
  return resolveUrl("VUE_APP_LOCALSERVER_API_BASE", "localServerApiBase", "localServerApiBase");
}

export function resolveLocalServerHostBase() {
  return resolveUrl("VUE_APP_LOCALSERVER_HOST_BASE", "localServerHostBase", "localServerHostBase");
}

export function resolveAuthApiBase() {
  return resolveUrl("VUE_APP_AUTH_API_BASE", "authApiBase", "authApiBase");
}
